export interface ListItem {
  value: number;
  label: string;
}

export const USER_ROLES = {
  UNASSIGNED: 0,
  STUDENT: 1,
  SCHOOL_OWNER: 2,
  INSTRUCTOR: 3,
  ADMIN: 4,
  MANAGER: 5,
  FRONT_DESK_MANAGER: 6
};

export enum UserRole {
  Admin = 'Admin',
  User = 'User',
  Guest = 'Guest',
}

export const USER_ROLE_OPTIONS: ListItem[] = [
  { value: USER_ROLES.UNASSIGNED, label: 'Unassigned' },
  { value: USER_ROLES.STUDENT, label: 'Student' },
  { value: USER_ROLES.SCHOOL_OWNER, label: 'School Owner' },
  { value: USER_ROLES.INSTRUCTOR, label: 'Instructor' },
  { value: USER_ROLES.ADMIN, label: 'Admin' },
  { value: USER_ROLES.MANAGER, label: 'Manager' },
  { value: USER_ROLES.FRONT_DESK_MANAGER, label: 'Front Desk Manager' },
];


export const getRoleLabel = (role: number) => {
  return USER_ROLE_OPTIONS.find((r) => r.value === role)?.label || String(role);
};
  